import React from 'react';
import { RouteObject } from 'react-router-dom';

const Home = React.lazy(() => import('../pages/home/Home'));
const Apps = React.lazy(() => import('../pages/apps/Apps'));
const TimerFlex = React.lazy(() => import('../pages/apps/timer-flex/TimerFlex'));
const PrivacyPolicy = React.lazy(() => import('../pages/apps/timer-flex/PrivacyPolicy'));
const TermsAndConditions = React.lazy(() => import('../pages/apps/timer-flex/TermsAndConditions'));
const Contact = React.lazy(() => import('../pages/contact/Contact'));

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/apps',
    element: <Apps />,
  },
  {
    path: '/apps/timer-flex',
    element: <TimerFlex />,
  },
  {
    path: '/apps/timer-flex/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/apps/timer-flex/terms',
    element: <TermsAndConditions />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
];

export const getBreadcrumbs = (pathname: string) => {
  const paths = pathname.split('/').filter(Boolean);
  const breadcrumbs = paths.map((path, index) => {
    const url = `/${paths.slice(0, index + 1).join('/')}`;
    const label = path.split('-').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
    
    return {
      label,
      url,
    };
  });

  return [{ label: 'Home', url: '/' }, ...breadcrumbs];
}; 